// a central place to format and serve time in nice display
import moment from 'moment'

// returns nice date time
export const niceDateTime = (value: Date): string => {
  return moment(value).format('D. MMM YYYY HH:mm')
}

// returns nice time
export const niceTime = (value: Date): string => {
  return moment(value).format('HH:mm')
}

// returns nice precise time
export const nicePreciseTime = (value?: Date): string => {
  const m = (value !== undefined) ? moment(value) : moment()
  return m.format('HH:mm:ss.SSS')
}

// returns nice date time, but excludes date if same as today
export const niceDateTimeWithoutTodaysDate = (value: Date): string => {
  if (moment().isSame(value, 'day')) {
    return niceTime(value)
  } else {
    return niceDateTime(value)
  }
}

// returns nice date
export const niceDate = (value: Date): string => {
  return moment(value).format('D. MMMM YYYY')
}

// returns nice short date used from chart etc.
export const niceShortDate = (value: Date): string => {
  return moment(value).format('D. MMMM')
}

// returns nice date time span
export const niceDateTimeSpan = (start: Date, end: Date): string => {
  const isOneDayEvent = moment(start).isSame(end, 'day')
  const startTime = moment(start).format('D. MMM YYYY HH:mm')
  const endTime = (isOneDayEvent) ? moment(end).format('HH:mm') : moment(end).format('D. MMM YYYY HH:mm')
  return startTime + ' - ' + endTime
}

// return a nice date from another date + durationMinutes
export const dateAddedMinutes = (start: Date, durationMinutes: number): Date => {
  return moment(start).add(durationMinutes, 'minutes').toDate()
}

// returns nice time span
export const niceTimeSpan = (start: Date, end: Date): string => {
  const isOneDayEvent = moment(start).isSame(end, 'day')
  const startTime = (isOneDayEvent) ? moment(start).format('HH:mm') : moment(start).format('D. MMM YYYY HH:mm')
  const endTime = (isOneDayEvent) ? moment(end).format('HH:mm') : moment(end).format('D. MMM YYYY HH:mm')
  return startTime + ' - ' + endTime
}

// returns true if dates are on same day
export const isSameDay = (start: Date, end: Date): boolean => {
  return (moment(start).isSame(end, 'day'))
}

// return if now is between 2 datetimes
export const isNow = (start: Date, durationMinutes: number): boolean => {
  const end = dateAddedMinutes(start, durationMinutes)
  const now = new Date()
  return (moment(now).isBefore(end, 'minute') && moment(now).isAfter(start))
}